import { PurchaseFormResponse, PurchaseItemResponse } from '@Types/api/form';
import { CollapseProps } from 'antd';
import { useMemo } from 'react';
import PanelHeader from '../PanelHeader/PanelHeader';
import MaterialCard from '../MaterialCard/MaterialCard';
import styles from './collapse-item.module.css';

interface CollapseItemsProps {
  requestsDataList: PurchaseFormResponse[];
  purchaseItems: Record<number, PurchaseItemResponse[]>;
  overviewItems: PurchaseItemResponse[];
  handleViewDetailes: (purchaseItem: PurchaseFormResponse) => void;
  handleAddMaterial: (purchaseItem: PurchaseItemResponse) => void;
  handleRemoveMaterial: (purchaseItem: PurchaseItemResponse) => void;
}

const CollapseItems = ({
  requestsDataList,
  purchaseItems,
  overviewItems,
  handleViewDetailes,
  handleAddMaterial,
  handleRemoveMaterial,
}: CollapseItemsProps): CollapseProps['items'] | undefined => {
  const matGroup = useMemo(() => {
    if (overviewItems.length) {
      const group = requestsDataList?.find((value) => {
        return value.reqId === overviewItems[0].reqID;
      });
      return group?.group3Id ?? undefined;
    }
    return undefined;
  }, [overviewItems, requestsDataList]);

  const prFor = useMemo(() => {
    if (overviewItems.length) {
      const pr = requestsDataList?.find((value) => {
        return value.reqId === overviewItems[0].reqID;
      });
      return pr?.prFor ?? undefined;
    }
    return undefined;
  }, [overviewItems, requestsDataList]);

  const mappedItems: CollapseProps['items'] = requestsDataList?.map(
    (purchaseItem) => {
      const items = purchaseItems[purchaseItem.reqId] || [];

      return {
        key: purchaseItem.reqId,
        label: (
          <PanelHeader
            title={`PR No. ${purchaseItem.reqNo}`}
            description={purchaseItem.group3Desc}
            onClick={() => handleViewDetailes(purchaseItem)}
          />
        ),
        children: (
          <div className={styles.materialsList} key={purchaseItem.reqId}>
            {items?.map((item) => {
              const itemsPrFor = requestsDataList.find(
                (pr) => pr.reqId === item.reqID
              )?.prFor;

              const isDifferentPrFor = Boolean(
                prFor && itemsPrFor && prFor !== itemsPrFor
              );

              const itemsGroup = requestsDataList.find(
                (pr) => pr.reqId === item.reqID
              )?.group3Id;

              const isDifferentGroup = Boolean(
                matGroup && itemsGroup && matGroup !== itemsGroup
              );

              const isBooked =
                item.tenderId !== null && item.purchaseTypeId > 0;

              return (
                <MaterialCard
                  key={item.reqItemId}
                  materialLabel={item.matDesc}
                  materialCode={item.matCode}
                  materialDescription={item.matDesc}
                  qty={item.reqQty}
                  unit={item.unitName}
                  isAdded={
                    !!overviewItems.find(
                      (overviewItem) =>
                        overviewItem?.reqItemId === item.reqItemId
                    )
                  }
                  isDisabled={isBooked || isDifferentPrFor || isDifferentGroup}
                  onAdd={() => !isBooked && handleAddMaterial(item)}
                  onRemove={() => handleRemoveMaterial(item)}
                />
              );
            })}
          </div>
        ),
      };
    }
  );

  return mappedItems;
};

export default CollapseItems;
